export const LifeInsuranceRoutes = {
    ROOT: "/life-insurance",
    PERSONAL_DATA: "/life-insurance/personal-data",
    NEW_PHONE: "/life-insurance/new-phone",
    NEW_ADDRESS: "/life-insurance/new-address",
    SUCCESS: "/life-insurance/success"
};



// WEBPACK FOOTER //
// ./src/components/lifeInsurance/LifeInsuranceRoutes.ts